import HhlaPageBase from './hhla-page-base'

export default class TitanicPage extends HhlaPageBase {
  static handleStylesApplied () {
    this.onEnter('.video_container', this.initVideo.bind(this))
  }

  static handleDOMReady () {
    super.handleDOMReady()
    this.mountRoomSchedule()
  }
}

TitanicPage.init()
